module.exports = __webpack_public_path__ + "static/media/right-transparent.bff36354.png";